import { TargetedSubscriberEnum, UnitEnum } from 'api/product';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { ProductFormValues } from './productFormValues';
import { ProductFormFieldNames } from './productFormFieldNames';
import { productValidationRules } from './productValidationRules';

/* createFormConfig seeds an empty string for every non-boolean/number/date/array
   rule, which does not match the declared type of these fields: the logo is a
   File, the notice period an object and the targeted subscriber an enum whose
   default is "any". Seed them explicitly so a pristine form already holds the
   shape the widgets and the submit handler expect. */
const productFormConfig = createFormConfig<ProductFormValues>(
  productValidationRules as ValidationRules<keyof ProductFormValues>,
  {
    [ProductFormFieldNames.Logo]: undefined,
    [ProductFormFieldNames.NoticePeriodDuration]: { value: null, unit: UnitEnum.Day },
    [ProductFormFieldNames.TargetedSubscriber]: TargetedSubscriberEnum.Any
  }
);

export { productFormConfig };
